import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Products from "@/pages/Products";
import ProductDetail from "@/pages/ProductDetail";
import HowItWorks from "@/pages/HowItWorks";
import Destinations from "@/pages/Destinations";
import Pricing from "@/pages/Pricing";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import About from "@/pages/About";
import Legal from "@/pages/Legal";
import CityPage from "@/pages/CityPage";
import Booking from "@/pages/Booking";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentResult";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import Bookings from "@/pages/admin/Bookings";
import Fleet from "@/pages/admin/Fleet";
import Cities from "@/pages/admin/Cities";
import Catalog from "@/pages/admin/Catalog";
import Promos from "@/pages/admin/Promos";
import ReviewsAdmin from "@/pages/admin/ReviewsAdmin";
import Customers from "@/pages/admin/Customers";

const PaymentWrap = ({ children }) => <LanguageProvider>{children}</LanguageProvider>;

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-center" richColors />
          <Routes>
            <Route path="/" element={<Navigate to="/fr" replace />} />

            {/* payment result (no lang prefix — Stripe uses origin) */}
            <Route path="/payment/success" element={<PaymentWrap><PaymentSuccess /></PaymentWrap>} />
            <Route path="/payment/cancel" element={<PaymentWrap><PaymentCancel /></PaymentWrap>} />

            {/* admin */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="bookings" element={<Bookings />} />
              <Route path="fleet" element={<Fleet />} />
              <Route path="cities" element={<Cities />} />
              <Route path="catalog" element={<Catalog />} />
              <Route path="promos" element={<Promos />} />
              <Route path="reviews" element={<ReviewsAdmin />} />
              <Route path="customers" element={<Customers />} />
            </Route>

            {/* public localized */}
            <Route path="/:lang" element={<Layout />}>
              <Route index element={<Home />} />
              <Route path="scooters" element={<Products categories={["scooter_mobility", "scooter_folding"]} titleKey="scooters" />} />
              <Route path="fauteuils-electriques" element={<Products category="wheelchair_electric" titleKey="wheelchairs" />} />
              <Route path="fauteuils-roulants" element={<Products category="wheelchair_manual" titleKey="manual" />} />
              <Route path="produit/:slug" element={<ProductDetail />} />
              <Route path="comment-ca-marche" element={<HowItWorks />} />
              <Route path="destinations" element={<Destinations />} />
              <Route path="tarifs" element={<Pricing />} />
              <Route path="faq" element={<FAQ />} />
              <Route path="contact" element={<Contact />} />
              <Route path="a-propos" element={<About />} />
              <Route path="cgv" element={<Legal type="cgv" />} />
              <Route path="confidentialite" element={<Legal type="privacy" />} />
              <Route path="mentions-legales" element={<Legal type="mentions" />} />
              <Route path="reservation" element={<Booking />} />
              <Route path=":seoSlug" element={<CityPage />} />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
